import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm, useFormContext } from "react-hook-form"
import { FilterMatchMode } from "primereact/api"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as myconst from "../../../constants/index"
import { Tooltip } from "primereact/tooltip";
import ParamsPopUp from "../Params-Info-popup";
import { InputTextarea } from "primereact/inputtextarea";
import { min } from "moment";
import { Button } from "primereact/button";
import SystemPromptModal from "components/SystemPromptModal";
import ReactMarkdown from 'react-markdown';
import styles from 'assets/styles/ai-chat-bot/markdownRenderer.module.css'; // Import your CSS module for React markdown
import { Slider } from "primereact/slider";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { infoIcon } from "assets/icons";
interface Field {
	key: string;
	type: 'text' | 'dropdown' | 'password';
	label?: any
}

const VoiceParamsLayer = ({ methods,
	fieldData,
	clientVersion,
	isVoiceDataChanged,
	setIsVoiceDataChanged,
	handelPrompt
}
	: any) => {

	const {
		// formState: { errors },
		// getValues
	} = useForm()

	const { register, setValue, formState: { errors }, watch, getValues } = useFormContext()


	const options = [
		"Text", "MongoDB"
	];

	const VoiceParamsFeilds = myconst.VoiceParamsFeilds;
	const [selectedCity, setSelectedCity] = useState()
	const [modalContent, setModalContent] = useState('');
	const [globalFilterValue, setGlobalFilterValue] = useState("")
	const [filters, setFilters] = useState<{ [s: string]: any }>()
	const [showSystemPromptModal, setShowSystemPromptModal] = useState<boolean>(false)
	const [test, setTest] = useState("");
	const [label, setLabel] = useState("");
	const [prompt, setPrompt] = useState("");
	const [values, setValues] = useState("");
	// const [slideValue, setSlideValue] = useState(0);

	const [rangeValue, setRangeValue] = useState(getValues("faiss_vactor_db.source_info_threshold")); // Initial value
	const [textValue, setTextValue] = useState(""); // Initial value
	const [tooltipPosition, setTooltipPosition] = useState({ left: 0, top: 0 });

	const handleChange = (event: any, maxValue: number) => {
		if (event.target.value > rangeValue && maxValue === 2) {
			setTextValue("With each increase in the threshold, Source Info's output will become less accurate, resulting in fewer relevant documents being retrieved.")
			setRangeValue(event.target.value); // Update rangeValue state when slider value changes
		} else if (event.target.value < rangeValue && maxValue === 2) {
			setTextValue("By lowering the threshold, Source Info's output will become more accurate, resulting in more relevant documents being retrieved.")
			setRangeValue(event.target.value); // Update rangeValue state when slider value changes
		}
		updateTooltipPosition(event, maxValue); // Update tooltip position
	};


	const updateTooltipPosition = (event: any, maxValue: number) => {
		const sliderWidth = event.target.offsetWidth;
		const sliderValue = parseFloat(event.target.value);
		const thumbWidth = 14; // Adjust according to your slider thumb size
		const tooltipWidth = 40; // Adjust according to your tooltip width
		const offsetLeft = ((sliderValue / maxValue) * (sliderWidth - thumbWidth) + (thumbWidth / 2) - (tooltipWidth / 2)) + 20;
		const offsetTop = -30; // Adjust top position as needed
		setTooltipPosition({ left: offsetLeft, top: offsetTop });

	};

	const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e?.target?.value
		let _filters = { ...filters }

		_filters["global"]!.value = value

		setFilters(_filters)
		setGlobalFilterValue(value)
	}

	const getFormErrorMessage = (name: any) => {
		return (
			errors[name] && (
				<small className="p-error">{errors[name]?.message?.toString()}</small>
			)
		)
	}

	const modals = [
		"System Prompt",
		"NER",
		"Summarization",
		"Classification",
		"Document Training System Prompt"
	]

	interface Option {
		name: number | boolean | string;
	}

	interface VoiceParams {
		'voice_params.max_new_tokens': Option[];
		'voice_params.chunk_length_s': Option[];
		'voice_params.batch_size': Option[];
	}

	const dropdownOptions: VoiceParams = {
		'voice_params.max_new_tokens': [{ name: 64 }, { name: 128 }, { name: 256 }],
		'voice_params.chunk_length_s': [{ name: 30 }, { name: 35 }, { name: 40 }],
		'voice_params.batch_size': [{ name: 10 }, { name: 15 }, { name: 16 }]
	};
	// This function returns a value dynamically from voiceParams using a key
	const getVoiceParam = (key: keyof VoiceParams) => {
		return dropdownOptions[key];
	}


	const initFilters = () => {
		setFilters({
			global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		})
		setGlobalFilterValue("")
	}


	useEffect(() => {
		initFilters()
	}, [])

	useEffect(() => {
		// setValues(fieldData)
		watch(
			(values) => {
				const changed = Object.keys(values).some((key) => {
					const originalValue = fieldData[key];
					const currentValue = values[key];
					return JSON.stringify(originalValue) !== JSON.stringify(currentValue);
				});
				setIsVoiceDataChanged(changed);
			},
			{ nested: true }
		);

	}, [watch])

	const logSource = getValues("log_source");

	// useEffect(() => {
	//     if (logSource === "Text") {
	//         setInitialFields(filteredData);
	//     } else {
	//         setInitialFields(feilds);
	//     }
	// }, [selectedCity])

	const getErrorMessage = (errorKey: string): string => {
		const nestedKeys = errorKey.split('.');
		let currentError: any = errors;

		for (const key of nestedKeys) {
			if (currentError && typeof currentError === 'object' && key in currentError) {
				currentError = currentError[key];
			} else {
				return '';
			}
		}
		return currentError?.message || '';
	};


	const getMinValueForRow = (key: any) => {
		switch (key) {
			case 'voice_params.max_new_tokens':
				return 126;
			case 'voice_params.chunk_length_s':
				return 27;
			case 'voice_params.batch_size':
				return 14;
			default:
				return 0;
		}
	};

	const getMaxValueForRow = (key: any) => {
		switch (key) {
			case 'voice_params.max_new_tokens':
				return 128;
			case 'voice_params.chunk_length_s':
				return 30;
			case 'voice_params.batch_size':
				return 16;
			default:
				return Infinity;
		}
	};



	return (
		<>
			<div className="datatable-wrapper">
				<div className="w-full mb-3">
					<IconField iconPosition="right" className='user-input'>
						<InputIcon className="pi pi-search"></InputIcon>
						<InputText
							value={globalFilterValue}
							onChange={onGlobalFilterChange}
							placeholder="Search by parameter"
							className='search-bar-input w-full'
							onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault(); }}
						/>
					</IconField>
				</div>
				<DataTable
					filters={filters}
					globalFilterFields={["label"]}
					showGridlines
					value={VoiceParamsFeilds}
					emptyMessage="No fields found."
					scrollable={true}
					scrollHeight='410px'
				>
					<Column
						header="Category"
						field="category"
						style={{ minWidth: '100px' }}
					/>

					<Column
						field="label"
						header="Parameter"
						style={{ minWidth: '300px' }}
						sortable
						body={(rowData: any, options: { rowIndex: number }) => {
							const targetId = `tooltip-${options.rowIndex}`;
							return (
								<><span className="header-tooltip">
									<span className={`tooltip-target-${options.rowIndex}`}>
										{rowData.label}
										<span className=" mr-2" style={{color: "#FF5155"}}>*</span>
										<i
											data-bs-toggle="modal"
											data-bs-target="#Params-Info"
											// id={targetId}
											onClick={() => setModalContent(rowData.toolTipInfo)}
											style={{ cursor: "pointer" }}
										>
											<img src={infoIcon} alt='info-icon' />
										</i>
										{/* <Tooltip target={`#${targetId}`} content={rowData.header} position="top" /> */}
									</span>
								</span>
								</>
							);
						}}
					>
					</Column>
					{/* <Column
					header="Description"
					style={{ width: '15%' }}
					body={(rowData: any, options: { rowIndex: number }) => {
						return (
							<>
							<span className="header-tooltip">
								<span className={`tooltip-target-${options.rowIndex}`}>
									<i
										data-bs-toggle="modal"
										data-bs-target="#Params-Info"
										id={targetId}
										className="pi pi-info-circle header-tooltip-icon ml-2"
										onClick={() => setModalContent(rowData.toolTipInfo)}
									></i>
									<Tooltip target={`#${targetId}`} content={rowData.header} position="top" />
								</span>
							</span>
								<div>
								</div>
							</>
						);
					}}
				/> */}

					<Column
						header="Field 1"
						field='field1'
						style={{ minWidth: '150px' }}
					/>
					<Column
						header="Field 2"
						field='field2'
						style={{ minWidth: '150px' }}
					/>
					<Column
						header="Value"
						style={{ minWidth: '150px' }}
						body={(rowData, index) => (
							<>
								{
									(rowData.type !== "text_area" && rowData.type !== "dropdown" && rowData.type !== "slider") ?
										(<>
											<Controller
												name={rowData.key}
												control={methods.control}
												rules={{
													required: `${rowData.label} is required`,
													...(rowData.type === "number" && {
														min: {
															value: getMinValueForRow(rowData.key),
															message: `Value must be minimum ${getMinValueForRow(rowData.key)} to maximum ${getMaxValueForRow(rowData.key)}`,
														},
														max: {
															value: getMaxValueForRow(rowData.key),
															message: `Value must be minimum ${getMinValueForRow(rowData.key)} to maximum ${getMaxValueForRow(rowData.key)}`,
														},
													}),
													...(rowData.key === "actual_pdf.actual_pdf_base_url" && {
														pattern: {
															value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
															message: "Enter a valid URL",
														},
													}),
													...(rowData.key === "faiss_vector_db.ron_main_vector_db_directory" && {
														pattern: {
															value: /^\/[\w\-./]*$/,
															message: "Enter correct path",
														},
													}),
												}}
												render={({ field }) => (
													<>
														<div className="param-tab-form">
															<div className='form-row'>
																<div className='form-col'>
																	<InputText
																		className="w-full"
																		disabled={clientVersion !== "" ? true : false || rowData.key === "lama_model_name.model_name_or_path" || rowData.key === "lama_model_name.model_basename" || rowData.key === "embedding_model_name.embedding_model_name" || rowData.key === "Metadata.version"}
																		type={rowData.type}
																		placeholder={
																			rowData.type === "number" ?
																				(isFinite(getMinValueForRow(rowData.key)) && isFinite(getMaxValueForRow(rowData.key))) ?
																					`Enter Number (${getMinValueForRow(rowData.key)} - ${getMaxValueForRow(rowData.key)})` :
																					"Enter Number"
																				:
																				rowData.type === "password"
																					? "Enter your password"
																					: "Enter your Text here"
																		}
																		{...field}
																	/>
																	<p style={{color: "#FF5155"}}>{getErrorMessage(rowData.key)}</p>
																</div>
															</div>
														</div>
													</>
												)}
											/>
										</>)
										: rowData.type === "dropdown" ? (
											<Controller
												name={rowData.key}
												control={methods.control}
												// defaultValue=""
												rules={{
													required: `${rowData.field} is Required`,
												}}
												render={({ field }) => (
													<>
														<div className="param-tab-form">
															<div className='form-row'>
																<div className='form-col'>
																	<Dropdown
																		{...field}
																		options={getVoiceParam(rowData.key)}
																		onChange={(e) => setValue(rowData.key, e.target.value, { shouldValidate: true })}
																		placeholder="Select an option"
																		value={field.value}
																		optionLabel="name"
																		className={`w-100`}
																		disabled={clientVersion !== "" ? true : false}
																	/>
																	<p style={{color: "#FF5155"}}>{errors[`${rowData.field}`]?.message?.toString()}</p>
																</div>
															</div>
														</div>
													</>
												)}
											/>
										)
											:
											rowData.type === "slider" ? (
												<Controller
													name={rowData.key}
													control={methods.control}
													render={({ field: { onBlur, onChange, value } }) => (
														<div className="w-full">
															{/* <div className="d-flex justify-content-center fw-bold align-items-center">
                                                            <span style={{ fontSize: "large" }}>{field.value ? field.value : 0}</span>
                                                        </div> */}
															{/* <div style={{ position: 'relative' }}> */}
															{/* <div className="d-flex align-items-center"> */}
															{/* <p className="mr-3">{0}</p> */}
															{/* <Slider
                                                                {...field}
                                                                className="w-full"
                                                                onChange={(e: any) => {
                                                                    // setSlideValue(e.target.value);
                                                                    setValue(rowData.key, e.value, { shouldValidate: true });
                                                                }}
                                                                min={0}
                                                                max={rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1}
                                                                step={0.1}
                                                                value={field.value}
                                                            /> */}
															<div className="range-slider-container">
																<div className="d-flex flex-column mt-4">
																	<span>
																		<input
																			type="range"
																			className="w-full"
																			min={0} // Minimum value
																			max={rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1} // Maximum value
																			value={value} // Current value
																			onChange={(e) => { handleChange(e, rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1); onChange(e.target.value) }} // Handle change event
																			onMouseOver={(e) => { updateTooltipPosition(e, rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1); }}
																			step={0.1}
																			disabled={clientVersion !== "" ? true : false}
																		/>
																		{/* Tooltip to display current value */}
																		{value &&
																			<span className="tooltip" style={{ left: tooltipPosition.left, top: tooltipPosition.top }}>
																				{value}
																			</span>
																		}
																	</span>
																	<div className="d-flex justify-content-between">
																		<span className="fw-bold">0</span>
																		<span className="fw-bold">{rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1}</span>
																	</div>
																</div>


															</div>
															{rowData.key === "faiss_vactor_db.source_info_threshold" &&
																<span className="fw-medium">{textValue}</span>
															}
															{/* <p className="ml-3">{rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1}</p> */}
															{/* </div> */}
															{/* <div style={{ position: 'absolute', top: '-8px', left: '50%', transform: 'translateX(-50%)', fontWeight: "500" }}> */}

															{/* <p className="text-danger">{getErrorMessage(rowData.key)}</p> */}
														</div>
													)}
												/>

											)
												// :
												// modals.includes(rowData.label) ?
												// 	(
												// 		// <div className='d-flex'>
												// 		// 	<Button className='btn btn-primary  btn-sm px-3' data-bs-toggle="modal" data-bs-target="#active-deactive" onClick={(e) => {
												// 		// 		handleSystemPrompt(e, rowData)
												// 		// 	}}>Click here</Button>

												// 		// </div>
												// 		<span className="c-pointer" data-bs-toggle="modal" data-bs-target="#active-deactive" onClick={(e) => {
												// 			handleSystemPrompt(e, rowData)
												// 		}} >
												// 			<Controller
												// 				name={rowData.key}
												// 				control={methods.control}
												// 				render={({ field }) => (
												// 					<>
												// 						{/* <InputTextarea
												// 					{...field}
												// 					value={temp(field?.value) as any}
												// 					// value={JSON.parse(field?.value)}
												// 					// disabled={true}
												// 					// disabled={clientVersion !== "" ? true : false}
												// 					readOnly
												// 					rows={5}
												// 					cols={30}
												// 					className="w-full c-pointer"
												// 				/> */}
												// 						<div className="border border-secondary-subtle p-1 d-flex flex-column justify-content-between ">
												// 							{/* <ReactMarkdown>{`${JSON.parse(field?.value).slice(0, 150)}...`}</ReactMarkdown> */}
												// 							{/* {MarkdownRenderer(field?.value)} */}
												// 							<ReactMarkdown>
												// 								{`${JSON.parse(JSON.stringify(field?.value)).slice(0, 150)}${field?.value.length > 150 ? "..." : ""}`}
												// 							</ReactMarkdown>
												// 							<span className="fw-bold text-primary c-pointer">View more</span>
												// 							{/* <span className="fw-bold d-flex flex-row-reverse text-primary">View more</span> */}
												// 						</div>
												// 						{/* <p className="text-danger">{errors[`${rowData.field}`]?.message?.toString()}</p> */}
												// 					</>
												// 				)}
												// 			/>
												// 			{/* <div>
												// 		{markdown(rowData)}
												// 	</div> */}
												// 		</span>
												// 	)
												:
												(
													<>
														<Controller
															name={rowData.key}
															control={methods.control}
															defaultValue=""
															rules={{
																required: `${rowData.field} is Required`,
															}}
															render={({ field }) => (
																<>
																	<InputTextarea
																		{...field}
																		disabled={clientVersion !== "" ? true : false}
																		rows={5}
																		cols={30}
																		className="w-full "
																	/>
																	<p style={{color: "#FF5155"}}>{errors[`${rowData.field}`]?.message?.toString()}</p>
																</>
															)}
														/>
													</>
												)
									// (<>
									//     <Controller
									//         name={rowData.key}
									//         control={control}
									//         // defaultValue={null}
									//         rules={{ required: 'Please select a log source' }}
									//         render={({ field }) => (
									//             <Dropdown
									//                 id={rowData.key}
									//                 onChange={(e) => {
									//                     field.onChange(e.target.value)
									//                     setSelectedCity(e.target.value)
									//                 }}
									//                 value={field.value}
									//                 placeholder="Select Log source"
									//                 options={options}
									//                 className={`w-100  border-0`}
									//             />
									//         )}
									//     />
									//     <p className="text-danger">
									//         {errors[`${rowData.key}`]?.message?.toString()}
									//     </p>
									// </>)
								}
							</>
						)}
					/>
				</DataTable >
			</div>
			<ParamsPopUp content={modalContent} />
			{/* <SystemPromptModal showSystemPromptModal={showSystemPromptModal} handleCloseSystemPrompt={handleCloseSystemPrompt} label={label} prompt={prompt} handelPrompt={handelPrompt2} /> */}
		</>
	);

};

export default VoiceParamsLayer;